import { EmployeeNodeModel, EmployeeNodeModelAPI } from '../../../../models';

export const getEmployeeNodesAdapter = (
    responseAPI: EmployeeNodeModelAPI[]
): EmployeeNodeModel[] => {
    return responseAPI
        ? responseAPI.map((employeeNode) => {
              return {
                  id: employeeNode.id,
                  parent: employeeNode.parent,
                  text: employeeNode.text,
                  documentNumber: employeeNode.documentNumber,
                  cardNumber: employeeNode.cardNumber,
                  droppable: employeeNode.droppable,
                  totalByGroup: employeeNode.totalByGroup,
              };
          })
        : [];
};
